import Button from "components/atoms/Button/Button"
import { Empty } from "components/atoms/Empty"
import InputField from "components/atoms/InputField/InputField"
import { useCallback, useMemo, useState } from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"
import { SocialScrapingKeyword } from "types/scraping/socialScraping.type"
import constants from "utils/constants"
import { emptyMessages } from "utils/message"
interface ManageKeywordsProps {
    keywords: SocialScrapingKeyword[]
    isLoading: boolean
    handleAddKeyword: (keyword: string[]) => void
    handleRemoveKeyword: (keywordId: string) => void
    handleScrapData: () => void
}
export const ManageKeywords: React.FC<ManageKeywordsProps> = (props) => {
    const { keywords, isLoading, handleAddKeyword, handleRemoveKeyword, handleScrapData } = props
    const [tempKeywords, setTempKeywords] = useState<string[]>([])
    const form = useForm({
        defaultValues: {
            keyword: ''
        },
    })
    const handleAddNewKeyword = (data: { keyword: string }) => {
        if (!data.keyword) return
        const keyword = data.keyword
        setTempKeywords(old => [...old, keyword])
        form.reset()
    }
    const handleDeleteKeyword = useCallback((keyword: string) => {
        handleRemoveKeyword(keyword)
    }, [])
    const handleDeleteTempKeyword = useCallback((keyword: string) => {
        setTempKeywords(old => old.filter(item => item !== keyword))
    }, [tempKeywords])
    const handleSubmit = useCallback(
        () => {
            if(keywords.length === 0) {
                handleScrapData()
            }
            handleAddKeyword(tempKeywords)
            form.reset()
            setTempKeywords([])
        }, [tempKeywords])
    const limitKeyword = useMemo(() => {
        if ((tempKeywords.length + keywords.length) >= constants.LIMIT_KEYWORDS) {
            return true
        }
        return false
    }, [keywords, tempKeywords])
    return (
        <div className="flex flex-col w-full gap-4">
                <div className="flex flex-col gap-2 mb-3">
                    <div className="flex items-center gap-1 mb-4">
                        <h3 className="text-white-500 font-bold text-lg">Add Keywords</h3>
                    </div>
                    <FormProvider {...form}>
                        <form className="flex flex-row items-center gap-4" onSubmit={form.handleSubmit(handleAddNewKeyword)}>
                            <Controller
                                control={form.control}
                                name="keyword"
                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                    <InputField disabled={limitKeyword} size="small" placeholder="keyword" onChange={onChange} onBlur={onBlur} value={value} />
                                )}
                            />
                            <Button disabled={limitKeyword || form.watch('keyword') === ''} size="sm" iconName="plus">Add</Button>
                        </form>
                    </FormProvider>
                    {limitKeyword && <small className="text-gray-400">* do you can add only 10 items</small>}
                </div>
                {tempKeywords.length > 0 && !isLoading && (
                    <div className="flex flex-col gap-2 w-full mb-4">
                        <small className="w-full text-left text-gray-400">not saved keywords</small>
                        <div className="flex gap-4 flex-row flex-wrap">
                            {tempKeywords.map((keyword, index) => (
                                <div key={keyword} className="flex items-center gap-2">
                                    <div key={keyword} className="items-center gap-2">
                                        <Button iconName="close" size="sm" action="button" type="outline" onClick={() => handleDeleteTempKeyword(keyword)} >
                                            {keyword}
                                        </Button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {keywords.length > 0 && (
                    <div className="flex flex-col gap-2">
                        {/* <small className="w-full text-left text-gray-400">Saved keywords</small> */}
                        <div className="flex gap-3 flex-row flex-wrap">
                            {keywords.map((keywordItem) => (
                                <Button key={keywordItem.id} iconName="close" size="xs" action="button" onClick={() => handleDeleteKeyword(keywordItem.id)} >
                                    {keywordItem.keyword}
                                </Button>
                            ))}
                        </div>
                    </div>
                )}
                {!keywords.length && !tempKeywords.length && (
                    <div className="flex flex-col gap-2 mt-5 opacity-80">
                        <Empty title={emptyMessages.keywords} message='Add new keywords' />
                    </div>
                )}
                <hr className="h-px bg-gray-800 border-0" />
                <div className="flex flex-row gap-4">
                    <Button action="button" isProcessing={isLoading} iconName="save" disabled={!tempKeywords.length || isLoading} onClick={handleSubmit}>Confirm</Button>
                </div>
        </div>
    )
}